<template>
  <main class="home">
    <HistoricalBalances :isDelinquent="isDelinquent" />
  </main>
</template>

<script lang="ts" setup>
import { onBeforeMount, getCurrentInstance, computed } from "vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import HistoricalBalances from "@/apps/credit-line/components/HistoricalBalances.vue";
import { useCreditLineSummary } from "@/apps/credit-line/hooks/useCreditLineSummary";
import { checkDelinquency } from "@/apps/credit-line/helpers/checkDeliquency.helper";

const { summary, fetchSummary } = useCreditLineSummary();

onBeforeMount(async () => {
  const instance = getCurrentInstance();
  await setLanguage(instance?.proxy);
  await fetchSummary();
});

const isDelinquent = computed(() => {
  const s = summary.value;
  if (!s) return false;
  return checkDelinquency(s);
});
</script>
